import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admin--page-override-form"
export default class extends Controller {
  static targets = ["form"]

  connect() {
    this.dirty = false
    this.initialSnapshot = null
    this.handleFormInput = this.handleFormInput.bind(this)
    this.element.dataset.pageOverrideDirty = "false"

    if (this.hasFormTarget) {
      this.formTarget.addEventListener("input", this.handleFormInput)
      this.formTarget.addEventListener("change", this.handleFormInput)
      this.captureCurrentStateAsClean()
      requestAnimationFrame(() => this.captureCurrentStateAsClean())
    }
  }

  disconnect() {
    if (!this.hasFormTarget) return

    this.formTarget.removeEventListener("input", this.handleFormInput)
    this.formTarget.removeEventListener("change", this.handleFormInput)
  }

  handleFormInput() {
    if (!this.hasFormTarget || this.initialSnapshot === null) return
    this.setDirty(this.serializeForm(this.formTarget) !== this.initialSnapshot)
  }

  setDirty(dirty, { force = false } = {}) {
    if (!force && this.dirty === dirty) return

    this.dirty = dirty
    this.element.dataset.pageOverrideDirty = dirty ? "true" : "false"
    this.element.dispatchEvent(new CustomEvent(
      dirty ? "page-builder:inspector-dirty" : "page-builder:inspector-clean",
      { bubbles: true }
    ))
  }

  captureCurrentStateAsClean() {
    if (!this.hasFormTarget) return

    this.initialSnapshot = this.serializeForm(this.formTarget)
    this.setDirty(false, { force: true })
  }

  serializeForm(form) {
    const formData = new FormData(form)
    const entries = []

    for (const [key, value] of formData.entries()) {
      if (value instanceof File) {
        entries.push(`${key}=__file__:${value.name}:${value.size}:${value.lastModified}`)
      } else {
        entries.push(`${key}=${value}`)
      }
    }

    return entries.join("&")
  }
}
